import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postHealthFiveStart,
  postHealthFiveSuccess,
  postHealthFiveFailure,
} from "../reducers/postHealthFiveReducer.js";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postHealthFive = createAsyncThunk(
  "postHealthFive",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postHealthFiveStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Health/SaveHealthFifthPage`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );
      console.log(values, "<=========values");
      const responseData = await response;

      thunkAPI.dispatch(postHealthFiveSuccess(values));

      return responseData;
    } catch (error) {
      if (error.response.data.Message) {
        thunkAPI.dispatch(postHealthFiveFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postHealthFiveFailure(error.response.data.status));
      }

      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
